export var OperationStatus;
(function (OperationStatus) {
    OperationStatus["Success"] = "success";
    OperationStatus["Failed"] = "failed";
    OperationStatus["InProgress"] = "inProgress";
})(OperationStatus || (OperationStatus = {}));
export var TransmissionStatus;
(function (TransmissionStatus) {
    TransmissionStatus["Success"] = "success";
    TransmissionStatus["Failed"] = "failed";
    TransmissionStatus["InProgress"] = "inProgress";
})(TransmissionStatus || (TransmissionStatus = {}));
export var OperationType;
(function (OperationType) {
    OperationType["UploadFile"] = "uploadFile";
    OperationType["MakeDirectory"] = "makeDirectory";
    OperationType["RenameFile"] = "renameFile";
    OperationType["DeleteDirectory"] = "deleteDirectory";
})(OperationType || (OperationType = {}));
